import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import dancer from "../../images/dancingstars/dance.jpg";

export default function DancingWithStarsAbout() {
  const { t } = useTranslation("dancingstarsabout");

  return (
    <Box
      sx={{
        background: "linear-gradient(to bottom, #0b0b0b 0%, #1a1a1a 100%)",
        py: { xs: 8, md: 16 },
        px: { xs: 3, md: 10 },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "space-between",
        gap: { xs: 6, md: 8 },
      }}
    >
      {/* Text Section */}
      <Box sx={{ flex: 1, maxWidth: 700 }}>
        <Typography
          sx={{
            fontFamily: "Playfair Display",
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 700,
            mb: 4,
            color: "#ffffff",
          }}
        >
          {t("title")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.8,
            color: "#ccc",
            mb: 4,
          }}
        >
          {t("description1")}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontSize: { xs: "1rem", md: "1.2rem" },
            lineHeight: 1.8,
            color: "#ccc",
            mb: 6,
          }}
        >
          {t("description2")}
        </Typography>

        {/* CTA Button */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          style={{ display: "inline-block" }}
        >
          <Button
            href="mailto:dancingwithstars@helvieta.com"
            sx={{
              position: "relative",
              overflow: "hidden",
              px: { xs: 5, md: 8 },
              py: { xs: 1.5, md: 2.5 },
              color: "#ffffff",
              fontWeight: 600,
              fontSize: { xs: "0.9rem", md: "1.1rem" },
              border: "2px solid #fff",
              borderRadius: "50px",
              textTransform: "uppercase",
              "&:before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.3), rgba(255,255,255,0.1))",
                transition: "all 0.5s ease",
              },
              "&:hover:before": {
                left: "100%",
              },
            }}
          >
            {t("cta")}
          </Button>
        </motion.div>
      </Box>

      {/* Image Section */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: { xs: 200, md: 400 },
          maxWidth: { md: 500 }, // Ensures desktop image doesn’t stretch too much
        }}
      >
        <img
          src={dancer}
          alt="Dancing With Stars"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover", // Maintains aspect ratio
            borderRadius: "16px", // Optional rounded corners
          }}
        />
      </Box>
    </Box>
  );
}
